// Texts of the checkout's contact step (Order/OrderContact.js) and the
// "How did you hear about us?" dropdown. Keys start with "contact.".

const en = {
  "contact.title": "Your Contact",
  "contact.createAccount": "Create an Account",
  "contact.haveAccount": "If you have an account",
  "contact.signIn": "Sign in",
  "contact.accountBenefits": "Creating an account allows you to access your quote and order history, saved addresses, payment methods, and site preferences anytime.",
  "contact.hearTitle": "How did you hear about us?",
  "contact.chooseOne": "Choose one",
  "contact.selectOption": "Select an option",
};

const es = {
  "contact.title": "Sus datos de contacto",
  "contact.createAccount": "Crear una cuenta",
  "contact.haveAccount": "¿Ya tiene una cuenta?",
  "contact.signIn": "Inicie sesión",
  "contact.accountBenefits": "Con una cuenta puede ver en cualquier momento su historial de cotizaciones y pedidos, sus direcciones guardadas, sus métodos de pago y sus preferencias.",
  "contact.hearTitle": "¿Cómo se enteró de nosotros?",
  "contact.chooseOne": "Elija una opción",
  "contact.selectOption": "Seleccione una opción",
};

const pt = {
  "contact.title": "Seus dados de contato",
  "contact.createAccount": "Criar uma conta",
  "contact.haveAccount": "Já tem uma conta?",
  "contact.signIn": "Entre",
  "contact.accountBenefits": "Com uma conta, você pode ver a qualquer momento seu histórico de orçamentos e pedidos, seus endereços salvos, suas formas de pagamento e suas preferências.",
  "contact.hearTitle": "Como você nos conheceu?",
  "contact.chooseOne": "Escolha uma opção",
  "contact.selectOption": "Selecione uma opção",
};

const texts = { en, es, pt };

export default texts;
